module.exports = __webpack_public_path__ + "static/img/icon-5.ba8bffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/icon-5.png
// module id = yfUs
// module chunks = 0